import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "./auth/auth.guard";
import { OAuthGuard } from "@santander/security-angular";
import { OAuthCallbackComponent } from "./modules/login/oauth-callback/oauth-callback.component";
import { OAuthInitComponent } from "./modules/login/oauth-init/oauth-init.component";

const routes: Routes = [
  { path: "", redirectTo: "init-callback", pathMatch: "full" },
  { path: "init-callback", component: OAuthInitComponent },
  {
    path: "login",
    loadChildren: () =>
      import("./modules/login/login.module").then((m) => m.LoginModule),
  }, {
    path: "gestionEmpleados",
    loadChildren: () =>
      import("./modules/gestion-empleados/gestion-empleados.module").then((m) => m.GestionEmpleadosModule),
  },
  {
    path: "oauth-callback",
    component: OAuthCallbackComponent,
    canActivate: [OAuthGuard],
  },
  {
    path: "presc-comerciales",
    loadChildren: () =>
      import("./modules/presc-comerciales/presc-comerciales.module").then(
        (m) => m.PrescComercialesModule
      ),
    canActivate: [OAuthGuard],
  },
  {
    path: "inicio",
    loadChildren: () =>
      import("./modules/inicio/inicio.module").then((m) => m.InicioModule),
    canActivate: [OAuthGuard],
  },
  {
    path: "presc",
    loadChildren: () =>
      import("./modules/presc-mapfre/presc-mapfre.module").then(
        (m) => m.PrescriptoresModule
      ),
    canActivate: [OAuthGuard],
  },
  {
    path: "presc-digital",
    loadChildren: () =>
      import("./modules/presc-digitales/presc-digitales.module").then(
        (m) => m.PrescDigitalesModule
      ),
    canActivate: [OAuthGuard]
  }
];

/**
 * AppRoutingModule
 * Designed to be the root routing module.
 *
 * imports:
 *  - RouterModule. Adds router directives and providers.
 *
 * exports:
 *  - RouterModule. The module with the configured routes.
 */
@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
